import React from "react";

import { Node } from "./node";
import s from "./tree.module.scss";
import { Paragraph, DivPx } from "@moai/core";

interface Props {
    value: string;
}

const useNode = (value: string) => {
    const [error, setError] = React.useState<string | null>(null);
    const [node, setNode] = React.useState<any>({});

    React.useEffect(() => {
        try {
            const obj = JSON.parse(value);
            setError(null);
            setNode(obj);
        } catch (error) {
            setError(error.message);
        }
    }, [value]);

    return { error, node };
};

const Error: React.FC<{ error: string }> = ({ error }) => (
    <>
        <div className={s.error}>
            <Paragraph>
                <span role="img" aria-label="exclamation mark">
                    ❗
                </span>
                <span> {error}</span>
            </Paragraph>
        </div>
        <DivPx size={16} />
    </>
);

export const Tree: React.FC<Props> = ({ value }) => {
    const { node, error } = useNode(value);

    return (
        <div className={s.container}>
            {error && <Error error={error} />}
            <div className={s.node}>
                <Node name="JSON" node={node} />
            </div>
        </div>
    );
};
